// =======================
import abkhazia from "./abkhazia.svg";
import afghanistan from "./afghanistan.svg";
import aland_islands from "./aland-islands.svg";
import albania from "./albania.svg";
import algeria from "./algeria.svg";
import american_samoa from "./american-samoa.svg";
import andorra from "./andorra.svg";
import angola from "./angola.svg";
import anguilla from "./anguilla.svg";
import antigua_and_barbuda from "./antigua-and-barbuda.svg";
import argentina from "./argentina.svg";
import armenia from "./armenia.svg";
import aruba from "./aruba.svg";
import australia from "./australia.svg";
import austria from "./austria.svg";
import azerbaijan from "./azerbaijan.svg";
import azores_islands from "./azores-islands.svg";
import bahamas from "./bahamas.svg";
import bahrain from "./bahrain.svg";
import balearic_islands from "./balearic-islands.svg";
import bangladesh from "./bangladesh.svg";
import barbados from "./barbados.svg";
import basque_country from "./basque-country.svg";
import belarus from "./belarus.svg";
import belgium from "./belgium.svg";
import belize from "./belize.svg";
import benin from "./benin.svg";
import bermuda from "./bermuda.svg";
import bhutan from "./bhutan.svg";
import bolivia from "./bolivia.svg";
import bonaire from "./bonaire.svg";
import bosnia_and_herzegovina from "./bosnia-and-herzegovina.svg";
import botswana from "./botswana.svg";
import brazil from "./brazil.svg";
import british_columbia from "./british-columbia.svg";
import british_indian_ocean_territory from "./british-indian-ocean-territory.svg";
import british_virgin_islands from "./british-virgin-islands.svg";
import brunei from "./brunei.svg";
import bulgaria from "./bulgaria.svg";
import burkina_faso from "./burkina-faso.svg";
import burundi from "./burundi.svg";
import cambodia from "./cambodia.svg";
import cameroon from "./cameroon.svg";
import canada from "./canada.svg";
import canary_islands from "./canary-islands.svg";
import cape_verde from "./cape-verde.svg";
import cayman_islands from "./cayman-islands.svg";
import central_african_republic from "./central-african-republic.svg";
import ceuta from "./ceuta.svg";
import chad from "./chad.svg";
import chile from "./chile.svg";
import china from "./china.svg";
import christmas_island from "./christmas-island.svg";
import cocos_island from "./cocos-island.svg";
import colombia from "./colombia.svg";
import comoros from "./comoros.svg";
import cook_islands from "./cook-islands.svg";
import corsica from "./corsica.svg";
import costa_rica from "./costa-rica.svg";
import croatia from "./croatia.svg";
import cuba from "./cuba.svg";
import curacao from "./curacao.svg";
import czech_republic from "./czech-republic.svg";
import democratic_republic_of_congo from "./democratic-republic-of-congo.svg";
import denmark from "./denmark.svg";
import djibouti from "./djibouti.svg";
import dominica from "./dominica.svg";
import dominican_republic from "./dominican-republic.svg";
import east_timor from "./east-timor.svg";
import ecuador from "./ecuador.svg";
import egypt from "./egypt.svg";
import el_salvador from "./el-salvador.svg";
import england from "./england.svg";
import equatorial_guinea from "./equatorial-guinea.svg";
import eritrea from "./eritrea.svg";
import estonia from "./estonia.svg";
import ethiopia from "./ethiopia.svg";
import european_union from "./european-union.svg";
import falkland_islands from "./falkland-islands.svg";
import fiji from "./fiji.svg";
import finland from "./finland.svg";
import france from "./france.svg";
import french_polynesia from "./french-polynesia.svg";
import gabon from "./gabon.svg";
import galapagos_islands from "./galapagos-islands.svg";
import gambia from "./gambia.svg";
import georgia from "./georgia.svg";
import germany from "./germany.svg";
import ghana from "./ghana.svg";
import gibraltar from "./gibraltar.svg";
import greece from "./greece.svg";
import greenland from "./greenland.svg";
import grenada from "./grenada.svg";
import guam from "./guam.svg";
import guatemala from "./guatemala.svg";
import guernsey from "./guernsey.svg";
import guinea_bissau from "./guinea-bissau.svg";
import guinea from "./guinea.svg";
import haiti from "./haiti.svg";
import hawaii from "./hawaii.svg";
import honduras from "./honduras.svg";
import hong_kong from "./hong-kong.svg";
import hungary from "./hungary.svg";
import iceland from "./iceland.svg";
import india from "./india.svg";
import indonesia from "./indonesia.svg";
import iran from "./iran.svg";
import iraq from "./iraq.svg";
import ireland from "./ireland.svg";
import isle_of_man from "./isle-of-man.svg";
import israel from "./israel.svg";
import italy from "./italy.svg";
import ivory_coast from "./ivory-coast.svg";
import jamaica from "./jamaica.svg";
import japan from "./japan.svg";
import jersey from "./jersey.svg";
import jordan from "./jordan.svg";
import kazakhstan from "./kazakhstan.svg";
import kenya from "./kenya.svg";
import kiribati from "./kiribati.svg";
import kosovo from "./kosovo.svg";
import kwait from "./kwait.svg";
import kyrgyzstan from "./kyrgyzstan.svg";
import laos from "./laos.svg";
import latvia from "./latvia.svg";
import lebanon from "./lebanon.svg";
import lesotho from "./lesotho.svg";
import liberia from "./liberia.svg";
import libya from "./libya.svg";
import liechtenstein from "./liechtenstein.svg";
import lithuania from "./lithuania.svg";
import luxembourg from "./luxembourg.svg";
import macao from "./macao.svg";
import madagascar from "./madagascar.svg";
import madeira from "./madeira.svg";
import malasya from "./malasya.svg";
import malawi from "./malawi.svg";
import maldives from "./maldives.svg";
import mali from "./mali.svg";
import malta from "./malta.svg";
import marshall_island from "./marshall-island.svg";
import martinique from "./martinique.svg";
import mauritania from "./mauritania.svg";
import mauritius from "./mauritius.svg";
import melilla from "./melilla.svg";
import mexico from "./mexico.svg";
import micronesia from "./micronesia.svg";
import moldova from "./moldova.svg";
import monaco from "./monaco.svg";
import mongolia from "./mongolia.svg";
import montenegro from "./montenegro.svg";
import montserrat from "./montserrat.svg";
import morocco from "./morocco.svg";
import mozambique from "./mozambique.svg";
import myanmar from "./myanmar.svg";
import namibia from "./namibia.svg";
import nato from "./nato.svg";
import nauru from "./nauru.svg";
import nepal from "./nepal.svg";
import netherlands from "./netherlands.svg";
import new_zealand from "./new-zealand.svg";
import nicaragua from "./nicaragua.svg";
import niger from "./niger.svg";
import nigeria from "./nigeria.svg";
import niue from "./niue.svg";
import norfolk_island from "./norfolk-island.svg";
import north_korea from "./north-korea.svg";
import northern_marianas_islands from "./northern-marianas-islands.svg";
import norway from "./norway.svg";
import oman from "./oman.svg";
import ossetia from "./ossetia.svg";
import pakistan from "./pakistan.svg";
import palau from "./palau.svg";
import palestine from "./palestine.svg";
import panama from "./panama.svg";
import papua_new_guinea from "./papua-new-guinea.svg";
import paraguay from "./paraguay.svg";
import peru from "./peru.svg";
import philippines from "./philippines.svg";
import pitcairn_islands from "./pitcairn-islands.svg";
import poland from "./poland.svg";
import portugal from "./portugal.svg";
import puerto_rico from "./puerto-rico.svg";
import qatar from "./qatar.svg";
import rapa_nui from "./rapa-nui.svg";
import republic_of_macedonia from "./republic-of-macedonia.svg";
import republic_of_the_congo from "./republic-of-the-congo.svg";
import romania from "./romania.svg";
import russia from "./russia.svg";
import rwanda from "./rwanda.svg";
import saba_island from "./saba-island.svg";
import sahrawi_arab_democratic_republic from "./sahrawi-arab-democratic-republic.svg";
import saint_kitts_and_nevis from "./saint-kitts-and-nevis.svg";
import samoa from "./samoa.svg";
import san_marino from "./san-marino.svg";
import sao_tome_and_prince from "./sao-tome-and-prince.svg";
import sardinia from "./sardinia.svg";
import saudi_arabia from "./saudi-arabia.svg";
import scotland from "./scotland.svg";
import senegal from "./senegal.svg";
import serbia from "./serbia.svg";
import seychelles from "./seychelles.svg";
import sicily from "./sicily.svg";
import sierra_leone from "./sierra-leone.svg";
import singapore from "./singapore.svg";
import sint_eustatius from "./sint-eustatius.svg";
import sint_maarten from "./sint-maarten.svg";
import slovakia from "./slovakia.svg";
import slovenia from "./slovenia.svg";
import solomon_islands from "./solomon-islands.svg";
import somalia from "./somalia.svg";
import somaliland from "./somaliland.svg";
import south_africa from "./south-africa.svg";
import south_korea from "./south-korea.svg";
import south_sudan from "./south-sudan.svg";
import spain from "./spain.svg";
import sri_lanka from "./sri-lanka.svg";
import st_barts from "./st-barts.svg";
import st_lucia from "./st-lucia.svg";
import st_vincent_and_the_grenadines from "./st-vincent-and-the-grenadines.svg";
import sudan from "./sudan.svg";
import suriname from "./suriname.svg";
import swaziland from "./swaziland.svg";
import sweden from "./sweden.svg";
import switzerland from "./switzerland.svg";
import syria from "./syria.svg";
import taiwan from "./taiwan.svg";
import tajikistan from "./tajikistan.svg";
import tanzania from "./tanzania.svg";
import thailand from "./thailand.svg";
import tibet from "./tibet.svg";
import togo from "./togo.svg";
import tokelau from "./tokelau.svg";
import tonga from "./tonga.svg";
import transnistria from "./transnistria.svg";
import trinidad_and_tobago from "./trinidad-and-tobago.svg";
import tunisia from "./tunisia.svg";
import turkey from "./turkey.svg";
import turkmenistan from "./turkmenistan.svg";
import turks_and_caicos from "./turks-and-caicos.svg";
import tuvalu_1 from "./tuvalu-1.svg";
import tuvalu from "./tuvalu.svg";
import uganda from "./uganda.svg";
import ukraine from "./ukraine.svg";
import united_arab_emirates from "./united-arab-emirates.svg";
import united_kingdom from "./united-kingdom.svg";
import united_nations from "./united-nations.svg";
import united_states from "./united-states.svg";
import uruguay from "./uruguay.svg";
import uzbekistn from "./uzbekistn.svg";
import vanuatu from "./vanuatu.svg";
import vatican_city from "./vatican-city.svg";
import venezuela from "./venezuela.svg";
import vietnam from "./vietnam.svg";
import virgin_islands from "./virgin-islands.svg";
import wales from "./wales.svg";
import yemen from "./yemen.svg";
import zambia from "./zambia.svg";
import zimbabwe from "./zimbabwe.svg";
// =======================
export var Flags = {
    "abkhazia": abkhazia,
    "afghanistan": afghanistan,
    "aland islands": aland_islands,
    "albania": albania,
    "algeria": algeria,
    "american samoa": american_samoa,
    "andorra": andorra,
    "angola": angola,
    "anguilla": anguilla,
    "antigua and barbuda": antigua_and_barbuda,
    "argentina": argentina,
    "armenia": armenia,
    "aruba": aruba,
    "australia": australia,
    "austria": austria,
    "azerbaijan": azerbaijan,
    "azores islands": azores_islands,
    "bahamas": bahamas,
    "bahrain": bahrain,
    "balearic islands": balearic_islands,
    "bangladesh": bangladesh,
    "barbados": barbados,
    "basque country": basque_country,
    "belarus": belarus,
    "belgium": belgium,
    "belize": belize,
    "benin": benin,
    "bermuda": bermuda,
    "bhutan": bhutan,
    "bolivia": bolivia,
    "bonaire": bonaire,
    "bosnia and herzegovina": bosnia_and_herzegovina,
    "botswana": botswana,
    "brazil": brazil,
    "british columbia": british_columbia,
    "british indian ocean territory": british_indian_ocean_territory,
    "british virgin islands": british_virgin_islands,
    "brunei": brunei,
    "bulgaria": bulgaria,
    "burkina faso": burkina_faso,
    "burundi": burundi,
    "cambodia": cambodia,
    "cameroon": cameroon,
    "canada": canada,
    "canary islands": canary_islands,
    "cape verde": cape_verde,
    "cayman islands": cayman_islands,
    "central african republic": central_african_republic,
    "ceuta": ceuta,
    "chad": chad,
    "chile": chile,
    "china": china,
    "christmas island": christmas_island,
    "cocos island": cocos_island,
    "colombia": colombia,
    "comoros": comoros,
    "cook islands": cook_islands,
    "corsica": corsica,
    "costa rica": costa_rica,
    "croatia": croatia,
    "cuba": cuba,
    "curacao": curacao,
    "czech republic": czech_republic,
    "democratic republic of congo": democratic_republic_of_congo,
    "denmark": denmark,
    "djibouti": djibouti,
    "dominica": dominica,
    "dominican republic": dominican_republic,
    "east timor": east_timor,
    "ecuador": ecuador,
    "egypt": egypt,
    "el salvador": el_salvador,
    "england": england,
    "equatorial guinea": equatorial_guinea,
    "eritrea": eritrea,
    "estonia": estonia,
    "ethiopia": ethiopia,
    "european union": european_union,
    "falkland islands": falkland_islands,
    "fiji": fiji,
    "finland": finland,
    "france": france,
    "french polynesia": french_polynesia,
    "gabon": gabon,
    "galapagos islands": galapagos_islands,
    "gambia": gambia,
    "georgia": georgia,
    "germany": germany,
    "ghana": ghana,
    "gibraltar": gibraltar,
    "greece": greece,
    "greenland": greenland,
    "grenada": grenada,
    "guam": guam,
    "guatemala": guatemala,
    "guernsey": guernsey,
    "guinea bissau": guinea_bissau,
    "guinea": guinea,
    "haiti": haiti,
    "hawaii": hawaii,
    "honduras": honduras,
    "hong kong": hong_kong,
    "hungary": hungary,
    "iceland": iceland,
    "india": india,
    "indonesia": indonesia,
    "iran": iran,
    "iraq": iraq,
    "ireland": ireland,
    "isle of man": isle_of_man,
    "israel": israel,
    "italy": italy,
    "ivory coast": ivory_coast,
    "jamaica": jamaica,
    "japan": japan,
    "jersey": jersey,
    "jordan": jordan,
    "kazakhstan": kazakhstan,
    "kenya": kenya,
    "kiribati": kiribati,
    "kosovo": kosovo,
    "kwait": kwait,
    "kyrgyzstan": kyrgyzstan,
    "laos": laos,
    "latvia": latvia,
    "lebanon": lebanon,
    "lesotho": lesotho,
    "liberia": liberia,
    "libya": libya,
    "liechtenstein": liechtenstein,
    "lithuania": lithuania,
    "luxembourg": luxembourg,
    "macao": macao,
    "madagascar": madagascar,
    "madeira": madeira,
    "malasya": malasya,
    "malawi": malawi,
    "maldives": maldives,
    "mali": mali,
    "malta": malta,
    "marshall island": marshall_island,
    "martinique": martinique,
    "mauritania": mauritania,
    "mauritius": mauritius,
    "melilla": melilla,
    "mexico": mexico,
    "micronesia": micronesia,
    "moldova": moldova,
    "monaco": monaco,
    "mongolia": mongolia,
    "montenegro": montenegro,
    "montserrat": montserrat,
    "morocco": morocco,
    "mozambique": mozambique,
    "myanmar": myanmar,
    "namibia": namibia,
    "nato": nato,
    "nauru": nauru,
    "nepal": nepal,
    "netherlands": netherlands,
    "new zealand": new_zealand,
    "nicaragua": nicaragua,
    "niger": niger,
    "nigeria": nigeria,
    "niue": niue,
    "norfolk island": norfolk_island,
    "north korea": north_korea,
    "northern marianas islands": northern_marianas_islands,
    "norway": norway,
    "oman": oman,
    "ossetia": ossetia,
    "pakistan": pakistan,
    "palau": palau,
    "palestine": palestine,
    "panama": panama,
    "papua new guinea": papua_new_guinea,
    "paraguay": paraguay,
    "peru": peru,
    "philippines": philippines,
    "pitcairn islands": pitcairn_islands,
    "poland": poland,
    "portugal": portugal,
    "puerto rico": puerto_rico,
    "qatar": qatar,
    "rapa nui": rapa_nui,
    "republic of macedonia": republic_of_macedonia,
    "republic of the congo": republic_of_the_congo,
    "romania": romania,
    "russia": russia,
    "rwanda": rwanda,
    "saba island": saba_island,
    "sahrawi arab democratic republic": sahrawi_arab_democratic_republic,
    "saint kitts and nevis": saint_kitts_and_nevis,
    "samoa": samoa,
    "san marino": san_marino,
    "sao tome and prince": sao_tome_and_prince,
    "sardinia": sardinia,
    "saudi arabia": saudi_arabia,
    "scotland": scotland,
    "senegal": senegal,
    "serbia": serbia,
    "seychelles": seychelles,
    "sicily": sicily,
    "sierra leone": sierra_leone,
    "singapore": singapore,
    "sint eustatius": sint_eustatius,
    "sint maarten": sint_maarten,
    "slovakia": slovakia,
    "slovenia": slovenia,
    "solomon islands": solomon_islands,
    "somalia": somalia,
    "somaliland": somaliland,
    "south africa": south_africa,
    "south korea": south_korea,
    "south sudan": south_sudan,
    "spain": spain,
    "sri lanka": sri_lanka,
    "st barts": st_barts,
    "st lucia": st_lucia,
    "st vincent and the grenadines": st_vincent_and_the_grenadines,
    "sudan": sudan,
    "suriname": suriname,
    "swaziland": swaziland,
    "sweden": sweden,
    "switzerland": switzerland,
    "syria": syria,
    "taiwan": taiwan,
    "tajikistan": tajikistan,
    "tanzania": tanzania,
    "thailand": thailand,
    "tibet": tibet,
    "togo": togo,
    "tokelau": tokelau,
    "tonga": tonga,
    "transnistria": transnistria,
    "trinidad and tobago": trinidad_and_tobago,
    "tunisia": tunisia,
    "turkey": turkey,
    "turkmenistan": turkmenistan,
    "turks and caicos": turks_and_caicos,
    "tuvalu 1": tuvalu_1,
    "tuvalu": tuvalu,
    "uganda": uganda,
    "ukraine": ukraine,
    "united arab emirates": united_arab_emirates,
    "united kingdom": united_kingdom,
    "united nations": united_nations,
    "united states": united_states,
    "uruguay": uruguay,
    "uzbekistn": uzbekistn,
    "vanuatu": vanuatu,
    "vatican city": vatican_city,
    "venezuela": venezuela,
    "vietnam": vietnam,
    "virgin islands": virgin_islands,
    "wales": wales,
    "yemen": yemen,
    "zambia": zambia,
    "zimbabwe": zimbabwe,
};
export default Flags;
// =======================